var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 15H9M9 15H11.6667M9 15V12.375M9 12.375H15.2222C16.2041 12.375 17 11.5915 17 10.625V2.75C17 1.7835 16.2041 1 15.2222 1H2.77778C1.79594 1 1 1.7835 1 2.75V10.625C1 11.5915 1.79594 12.375 2.77778 12.375H9Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopGray);
export default __webpack_public_path__ + "static/media/DesktopGray.c81d21919f35c797cecb4bd06d673022.svg";
export { ForwardRef as ReactComponent };